import React, { FC } from 'react'
import { ImageList, ImageListProps } from '@mui/material'

const EvtImageList: FC<ImageListProps> = ({ children, ...props }) => {
    return <ImageList {...props}>{children}</ImageList>
}

export default EvtImageList
